import script from "./assessment-result.vue?vue&type=script&setup=true&lang=js"
export * from "./assessment-result.vue?vue&type=script&setup=true&lang=js"

import "./assessment-result.vue?vue&type=style&index=0&id=0d533c27&lang=css"

const __exports__ = script;

export default __exports__